<template>
  <div class="form-element">
    <input
      v-numeric
      class="form-element__input -sms"
      type="tel"
      autocomplete="off"
      maxlength="1"
      minlength="1"
      @keyup="changed($event, 'code1')"
      ref="code1"
      v-model.trim="form.code1"
    />
    <input
      v-numeric
      class="form-element__input -sms"
      type="tel"
      autocomplete="off"
      maxlength="1"
      minlength="1"
      @keyup="changed($event, 'code2')"
      ref="code2"
      v-model.trim="form.code2"
    />
    <input
      v-numeric
      class="form-element__input -sms"
      type="tel"
      autocomplete="off"
      maxlength="1"
      minlength="1"
      @keyup="changed($event, 'code3')"
      ref="code3"
      v-model.trim="form.code3"
    />
    <input
      v-numeric
      class="form-element__input -sms"
      type="tel"
      autocomplete="off"
      maxlength="1"
      minlength="1"
      @keyup="changed($event, 'code4')"
      ref="code4"
      v-model.trim="form.code4"
    />
    <input
      v-numeric
      class="form-element__input -sms"
      type="tel"
      autocomplete="off"
      maxlength="1"
      minlength="1"
      @keyup="changed($event, 'code5')"
      ref="code5"
      v-model.trim="form.code5"
    />
    <input
      v-numeric
      class="form-element__input -sms"
      type="tel"
      autocomplete="off"
      maxlength="1"
      minlength="1"
      @keyup="changed($event, 'code6')"
      ref="code6"
      v-model.trim="form.code6"
    />
  </div>
</template>

<script>
import { numeric } from "@/directives/";
export default {
  props: {
    count: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      form: {
        code1: null,
        code2: null,
        code3: null,
        code4: null,
        code5: null,
        code6: null
      }
    };
  },
  directives: { numeric },
  watch: {
    form: {
      deep: true,
      handler: "isChange"
    },
    count: function() {
      this.clear();
    }
  },
  methods: {
    changed: function(e, src) {
      let vm = this;

      if (!vm.isNumeric(e)) return (vm.form[src] = null);

      if (e.keyCode == 46) return; // if press delete
      if (e.keyCode == 8 || e.keyCode == 37) return vm.prev(src); // if press backspace or left arrow

      if (src != "code6") vm.next(src);
    },
    prev: function(param) {
      let vm = this;

      if (param == "code1") return;

      let key = parseInt(param.slice(-1)) - 1;

      vm.$refs[`code${key}`].focus();
      vm.$refs[`code${key}`].select();
    },
    next: function(param) {
      let vm = this;

      let key = parseInt(param.slice(-1)) + 1;

      vm.$refs[`code${key}`].focus();
      vm.$refs[`code${key}`].select();
    },
    isNumeric: function(e) {
      let arr = [
        8,
        46,
        37,
        39,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105
      ];
      return arr.includes(e.keyCode);
    },
    isChange: function() {
      if (
        this.form.code1 &&
        this.form.code2 &&
        this.form.code3 &&
        this.form.code4 &&
        this.form.code5 &&
        this.form.code6
      ) {
        let val = `${this.form.code1.toString()}${this.form.code2.toString()}${this.form.code3.toString()}${this.form.code4.toString()}${this.form.code5.toString()}${this.form.code6.toString()}`;

        this.$emit("input", parseInt(val));
      } else {
        this.$emit("input", null);
      }
    },
    clear: function() {
      this.form.code1 = null;
      this.form.code2 = null;
      this.form.code3 = null;
      this.form.code4 = null;
      this.form.code5 = null;
      this.form.code6 = null;
    }
  }
};
</script>